// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './ScrollToTop';

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

if (!process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
    console.error('REACT_APP_RECAPTCHA_SITE_KEY is not defined. Please set it in frontend/.env');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
            <BrowserRouter>
                <ScrollToTop />
                <App />
            </BrowserRouter>
        </GoogleReCaptchaProvider>
    </React.StrictMode>
);

reportWebVitals();
